"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterWorkbenchDbMap = exports.listWorkbenchAPIDbMap = exports.workbenchStateOrder = exports.vmStateForUI = exports.WorkbenchInstanceState = exports.VMAppState = exports.GCPVMInstanceType = void 0;
var GCPVMInstanceType;
(function (GCPVMInstanceType) {
    GCPVMInstanceType["n2HighMem2"] = "n2-highmem-2";
    GCPVMInstanceType["n2HighMem4"] = "n2-highmem-4";
    GCPVMInstanceType["n2HighMem8"] = "n2-highmem-8";
    GCPVMInstanceType["n2HighMem16"] = "n2-highmem-16";
    GCPVMInstanceType["n2HighMem32"] = "n2-highmem-32";
    GCPVMInstanceType["n2HighMem48"] = "n2-highmem-48";
    GCPVMInstanceType["n2Standard4"] = "n2-standard-4";
    GCPVMInstanceType["n2Standard8"] = "n2-standard-8";
    GCPVMInstanceType["n2Standard16"] = "n2-standard-16";
    GCPVMInstanceType["n2Standard32"] = "n2-standard-32";
    GCPVMInstanceType["n2Standard48"] = "n2-standard-48";
    GCPVMInstanceType["n2Standard64"] = "n2-standard-64";
    GCPVMInstanceType["n2Standard80"] = "n2-standard-80";
    GCPVMInstanceType["n2Standard96"] = "n2-standard-96";
})(GCPVMInstanceType || (exports.GCPVMInstanceType = GCPVMInstanceType = {}));
var VMAppState;
(function (VMAppState) {
    VMAppState["Preparing"] = "Preparing";
    VMAppState["Creating"] = "Creating";
    VMAppState["Resuming"] = "Resuming";
    VMAppState["Running"] = "Running";
    VMAppState["Stopped"] = "Stopped";
    VMAppState["Terminated"] = "Terminated";
    VMAppState["Failed"] = "Failed";
})(VMAppState || (exports.VMAppState = VMAppState = {}));
var WorkbenchInstanceState;
(function (WorkbenchInstanceState) {
    WorkbenchInstanceState["Provisioning"] = "PROVISIONING";
    WorkbenchInstanceState["Staging"] = "STAGING";
    WorkbenchInstanceState["Resuming"] = "RESUMING";
    WorkbenchInstanceState["Running"] = "RUNNING";
    WorkbenchInstanceState["PendingStop"] = "PENDING_STOP";
    WorkbenchInstanceState["Repairing"] = "REPAIRING";
    WorkbenchInstanceState["Stopping"] = "STOPPING";
    WorkbenchInstanceState["Suspending"] = "SUSPENDING";
    WorkbenchInstanceState["Suspended"] = "SUSPENDED";
    WorkbenchInstanceState["Terminating"] = "TERMINATING";
    WorkbenchInstanceState["Terminated"] = "TERMINATED";
    WorkbenchInstanceState["Deleted"] = "DELETED";
    WorkbenchInstanceState["Failed"] = "FAILED";
})(WorkbenchInstanceState || (exports.WorkbenchInstanceState = WorkbenchInstanceState = {}));
const vmStateForUI = (status) => {
    switch (status) {
        case WorkbenchInstanceState.Provisioning:
        case WorkbenchInstanceState.Staging:
            return "Initializing";
        case WorkbenchInstanceState.Running:
            return "Running";
        case WorkbenchInstanceState.PendingStop:
        case WorkbenchInstanceState.Stopping:
            return "Stopping";
        case WorkbenchInstanceState.Repairing:
            return "Repairing";
        case WorkbenchInstanceState.Suspending:
            return "Suspending";
        case WorkbenchInstanceState.Suspended:
            return "Suspended";
        case WorkbenchInstanceState.Terminated:
            return "Stopped";
        case WorkbenchInstanceState.Terminating:
            return "Terminating";
        case WorkbenchInstanceState.Deleted:
            return "Terminated";
        case WorkbenchInstanceState.Failed:
            return "Failed";
        case WorkbenchInstanceState.Resuming:
            return "Resuming";
    }
};
exports.vmStateForUI = vmStateForUI;
exports.workbenchStateOrder = {
    [WorkbenchInstanceState.Provisioning]: 1,
    [WorkbenchInstanceState.Staging]: 2,
    [WorkbenchInstanceState.Resuming]: 3,
    [WorkbenchInstanceState.Running]: 4,
    [WorkbenchInstanceState.PendingStop]: 5,
    [WorkbenchInstanceState.Repairing]: 6,
    [WorkbenchInstanceState.Stopping]: 7,
    [WorkbenchInstanceState.Suspending]: 8,
    [WorkbenchInstanceState.Suspended]: 9,
    [WorkbenchInstanceState.Terminating]: 10,
    [WorkbenchInstanceState.Terminated]: 11,
    [WorkbenchInstanceState.Deleted]: 12,
    [WorkbenchInstanceState.Failed]: 13,
};
exports.listWorkbenchAPIDbMap = {
    id: "wi.id",
    name: "wi.name",
    workbench: "wi.workbench",
    status: "wi.vm_state",
    dateCreated: "wi.date_created",
    dateModified: "wi.date_modified",
    vmLastStateChangedAt: "wi.vm_state_last_changed_at",
};
exports.filterWorkbenchDbMap = {
    id: "wi.id",
    name: "wi.name",
    workbench: "wi.workbench",
    instanceType: "wi.instance_type",
    vmState: "wi.vm_state",
    appState: "wi.app_state",
    owner: "u.email",
    ownerId: "u.id",
    search: "CONCAT_WS(' ', wi.name, wi.workbench)",
};
